<template>
    <div v-if="activeMenu" 
         class="training-menu-overlay" 
         :class="{ 'top-left': activeMenu.menuType === 'two_to_four_option_half_screen' }">
        <menu-splash-screen
            v-if="activeMenu.menuType === 'splash_screen'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />

        <menu-two-option-large
            v-if="activeMenu.menuType === 'two_option_large'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />

        <menu-three-option-large
            v-if="activeMenu.menuType === 'three_option_large'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />

        <menu-two-to-six-option-full-screen
            v-if="activeMenu.menuType === 'two_to_six_option_full_screen'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />

        <menu-two-to-four-option-half-screen
            v-if="activeMenu.menuType === 'two_to_four_option_half_screen'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />

        <menu-infinite-option
            v-if="activeMenu.menuType === 'infinite_option'"
            :style-data="activeMenu.style"
            :menu-data="activeMenu.content"
            :is-style-preview="false"
            :enable-inline-edit="false"
            @button-clicked="handleButtonClick"
        />
    </div>
</template>

<script>
import MenuSplashScreen from 'shared/menus/menu-splash-screen.vue';
import MenuTwoOptionLarge from 'shared/menus/menu-two-option-large.vue';
import MenuThreeOptionLarge from 'shared/menus/menu-three-option-large.vue';
import MenuTwoToSixOptionFullScreen from 'shared/menus/menu-two-to-six-option-full-screen.vue';
import MenuTwoToFourOptionHalfScreen from 'shared/menus/menu-two-to-four-option-half-screen.vue';
import MenuInfiniteOption from 'shared/menus/menu-infinite-option.vue';

export default {
    name: 'TrainingMenuDisplay',
    
    components: {
        MenuSplashScreen,
        MenuTwoOptionLarge,
        MenuThreeOptionLarge,
        MenuTwoToSixOptionFullScreen,
        MenuTwoToFourOptionHalfScreen,
        MenuInfiniteOption
    },

    data() {
        return {
            activeMenu: null
        };
    },

    mounted() {
        this.connectToMenuManager();
    },

    beforeDestroy() {
        if (this.$root.$menuEventBus) {
            this.$root.$menuEventBus.$off('training:show-menu', this.showMenu);
            this.$root.$menuEventBus.$off('training:hide-menu', this.hideMenu);
            this.$root.$menuEventBus.$off('training:hide-all-menus', this.hideAllMenus);
        }
    },

    methods: {
        connectToMenuManager() {
            if (!this.$root.$menuEventBus) {
                this.$root.$menuEventBus = new this.$root.constructor();
            }

            if (typeof MenuManager !== 'undefined') {
                MenuManager.setVueEventBus(this.$root.$menuEventBus);
            } else {
                setTimeout(() => {
                    if (typeof MenuManager !== 'undefined') {
                        MenuManager.setVueEventBus(this.$root.$menuEventBus);
                    }
                }, 1000);
            }

            this.$root.$menuEventBus.$on('training:show-menu', this.showMenu);
            this.$root.$menuEventBus.$on('training:hide-menu', this.hideMenu);
            this.$root.$menuEventBus.$on('training:hide-all-menus', this.hideAllMenus);
        },

        showMenu(menuData) {
            const content = { ...menuData.content };
            
            if (content.image && content.image.imageResourceId) {
                content.image.imageUrl = `${location.origin}/iq3/image/${content.image.imageResourceId}`;
            }

            if (content.optionCards && Array.isArray(content.optionCards)) {
                content.optionCards = content.optionCards.map(card => {
                    const processedCard = { ...card };
                    if (processedCard.imageResourceId) {
                        processedCard.imageUrl = `${location.origin}/iq3/image/${processedCard.imageResourceId}`;
                    }
                    return processedCard;
                });
            }

            this.activeMenu = {
                actionId: menuData.actionId,
                menuType: menuData.menuType,
                style: menuData.style || {},
                content: {
                    ...content,
                    buttons: this.processButtons(content.buttons)
                },
                scene: menuData.scene
            };
        },

        hideMenu(data) {
            if (this.activeMenu && this.activeMenu.actionId === data.actionId) {
                this.activeMenu = null;
            }
        },

        hideAllMenus() {
            this.activeMenu = null;
        },

        processButtons(buttons) {
            if (!buttons || !Array.isArray(buttons)) {
                return [];
            }

            return buttons.map((btn, index) => ({
                ...btn,
                _originalAction: btn.action,
                onClick: () => this.handleButtonClick(index, btn)
            }));
        },

        handleButtonClick(buttonIndex, button) {
            const btn = this.activeMenu?.content?.buttons?.[buttonIndex];
            
            if (btn && btn._originalAction) {
                btn._originalAction();
            } else if (btn && btn.action) {
                btn.action();
            }
        }
    }
};
</script>

<style scoped>
.training-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.training-menu-overlay.top-left {
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: 80px;
    padding-left: 20px;
    left: 0;
    width: 35%;
    max-width: 35%;
}

.training-menu-overlay > * {
    pointer-events: auto;
    min-width: 600px;
}
</style>
